import React, { useState } from 'react';
import './ProPlan.css';

export default function ProPlanCard() {
  const [selectedPlan, setSelectedPlan] = useState('monthly');

  return (
    <div className={`pro-plan-card ${selectedPlan}`}>
      <img
        id="Pro-Plan-img-try"
        src="https://d1csarkz8obe9u.cloudfront.net/posterpreviews/vip-logo-design-template-098e8dfa032b844afcec2df88d1ff290_screen.jpg?ts=1738304438"
        alt=""
      />

      <h2 className="pro-title" style={{ color: '#ff6f00' }}>Pro</h2>

      <div className="plan-toggle">
        <br></br>
        <button
          className={`plan-button monthly-btn ${selectedPlan === 'monthly' ? 'active' : ''}`}
          onClick={() => setSelectedPlan('monthly')}
        >
          Mensuel - €19.99/mois
        </button>
        <br></br>
        <br></br>
        <button
          className={`plan-button annual-btn ${selectedPlan === 'annual' ? 'active' : ''}`}
          onClick={() => setSelectedPlan('annual')}
        >
          Annuel - €199.99/an
        </button>
      </div>

      <ul className="pro-plan-features">
        <li>   Accès complet à l'IA</li>
        <li>   Support vocal         </li>
        <li>  Historique illimité</li>
        <li>  ️Exportation rapide</li>
        <li>  Support prioritaire</li>
      </ul>

      <button
        className="continue-to-payment-button"
        onClick={() => {
          // Navigate to payment page with planType and billingPeriod params
          window.location.href = '/payment/pro/' + selectedPlan;
        }}
      >
        Continuer vers le paiement
      </button>
    </div>
  );
}
